/**
 * Builds the `redirect` search param value for login redirects.
 *
 * Concatenates pathname + search + hash so TanStack Router can encode it
 * as-is into `?redirect=...`. Avoids manual encodeURIComponent (login.tsx
 * already calls decodeURIComponent on the value).
 */
export function buildLoginRedirect(location: {
	pathname: string;
	searchStr: string;
	hash: string;
}): string {
	return `${location.pathname}${location.searchStr}${location.hash}`;
}
